// a simple script for Form inputs to add empty placeholders where placeholders do not exist
// this is important for SA brand Material v3 style inputs alignment.

import Component from './Component';

export default class Form extends Component {

  load() {
    console.log('Form loaded');
    this.initForm();
    super.load();
  }

  initForm() {

    document.querySelectorAll("input[type='text']:not([placeholder])").forEach(input => {
      input.setAttribute("placeholder", " ");
    });

  }

}
